import {
  SET_HOME_POST,
  FETCH_HOME_POSTS_START,
  FETCH_HOME_POSTS_SUCCESS,
  FETCH_HOME_POSTS_FAILURE,
  SEARCH_USER_START,
  SEARCH_USER_SUCCESS,
  SEARCH_USER_FAILURE,
  FETCH_OTHERS_SINGLE_POST_START,
  FETCH_OTHERS_SINGLE_POST_SUCCESS,
  FETCH_OTHERS_SINGLE_POST_FAILURE,
  FETCH_POST_SUGGESTION_START,
  FETCH_POST_SUGGESTION_SUCCESS,
  FETCH_POST_SUGGESTION_FAILURE,
  FETCH_LISTS_DETAILS_START,
  FETCH_LISTS_DETAILS_SUCCESS,
  FETCH_LISTS_DETAILS_FAILURE,
  UPDATE_POST_LIKES,
  UPDATE_POST_COMMENTS,
  INCREMENT_POST_TIPS_COUNT,
  UPDATE_POST_COMMENTS_COUNT,
  UPDATE_POST_BOOKMARK_STATUS,
  OPEN_UNLOCK_CONTENT_MODAL,
  CLOSE_UNLOCK_CONTENT_MODAL,
  UPDATE_POST_HAS_STORY_STATUS,
  UPDATE_POST_SUCCESS,
  SUBSCRIBE_TO_PLAN_SUCCESS,
} from "../actions/ActionConstant";
import {
  updatePostLike,
  mergeListOfPosts,
  replaceUpdatePost,
  modifyPostComments,
  incrementPostTipCount,
  modifyPostCommentCount,
  modifyPostBookmarkStatus,
  modifyPostHasStoryStatus,
  modifyPostOnUpdate,
  modifyPostOnSubscribedToPerformer,
} from "../../components/helper/Utils";

export const initialState = {
  postList: {
    data: {
      posts: [],
      page: 0,
      limit: 5,
      total: 0,
      totalPages: 0,
    },
    feedUrl: null,
    loading: true,
    error: false,
  },
  searchUser: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  singlePost: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  postSug: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  unlockContentModal: {
    isOpen: false,
    data: {},
  },
  lists: {
    data: {},
    loading: true,
    error: false,
  },
};

const HomeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_HOME_POST:
      return {
        ...state,
        postList: {
          ...state.postList,
          data: {
            ...state.postList.data,
            posts: replaceUpdatePost(
              state.postList.data?.posts,
              action.data.post
            ),
          }
        }
      };
    case FETCH_HOME_POSTS_START:
      return {
        ...state,
        postList: {
          ...state.postList,
          feedUrl: action.data.url || "all_posts",
          data:
            action.data.page === 0
              ? initialState.postList.data
              : state.postList.data,
          loading: true,
          error: false,
        },
      };
    case FETCH_HOME_POSTS_SUCCESS:
      return {
        ...state,
        postList: {
          ...state.postList,
          data: {
            ...action.data,
            posts: mergeListOfPosts(
              state.postList?.data.posts || [],
              action.data && action.data.posts ? action.data.posts : []
            ),
          },
          loading: false,
          error: false,
        },
      };
    case FETCH_HOME_POSTS_FAILURE:
      return {
        ...state,
        postList: {
          ...state.postList,
          data: {
            ...state.postList.data,
            posts: state.postList.data.posts || [],
          },
          loading: false,
          error: action.error,
        },
      };
    case SEARCH_USER_START:
      return {
        ...state,
        searchUser: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
          loadingButtonContent: "Loading...",
          buttonDisable: true,
        },
      };
    case SEARCH_USER_SUCCESS:
      return {
        ...state,
        searchUser: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case SEARCH_USER_FAILURE:
      return {
        ...state,
        searchUser: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };

    case FETCH_OTHERS_SINGLE_POST_START:
      return {
        ...state,
        singlePost: {
          inputData: action.data,
          data: {},
          loading: true,
          error: false,
          loadingButtonContent: "Loading... Please wait",
          buttonDisable: true,
        },
      };
    case FETCH_OTHERS_SINGLE_POST_SUCCESS:
      return {
        ...state,
        singlePost: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case FETCH_OTHERS_SINGLE_POST_FAILURE:
      return {
        ...state,
        singlePost: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };

    case FETCH_POST_SUGGESTION_START:
      return {
        ...state,
        postSug: {
          inputData: action.data,
          data: {},
          loading: true,
          error: false,
          loadingButtonContent: "Loading... Please wait",
          buttonDisable: true,
        },
      };
    case FETCH_POST_SUGGESTION_SUCCESS:
      return {
        ...state,
        postSug: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case FETCH_POST_SUGGESTION_FAILURE:
      return {
        ...state,
        postSug: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case FETCH_LISTS_DETAILS_START:
      return {
        ...state,
        lists: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case FETCH_LISTS_DETAILS_SUCCESS:
      return {
        ...state,
        lists: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_LISTS_DETAILS_FAILURE:
      return {
        ...state,
        lists: {
          data: {},
          loading: true,
          error: action.error,
        },
      };
    case UPDATE_POST_LIKES:
      return {
        ...state,
        postList: {
          ...state.postList,
          data: {
            ...state.postList.data,
            posts: updatePostLike(state.postList.data.posts, action.data),
          },
        },
      };
    case UPDATE_POST_HAS_STORY_STATUS:
      return {
        ...state,
        postList: {
          ...state.postList,
          data: {
            ...state.postList.data,
            posts: modifyPostHasStoryStatus(state.postList.data.posts, action.data),
          },
        },
      };
    case SUBSCRIBE_TO_PLAN_SUCCESS:
      return {
        ...state,
        postList: {
          ...state.postList,
          data: {
            ...state.postList.data,
            posts: modifyPostOnSubscribedToPerformer(state.postList.data.posts, action.data)
          }
        }
      }
    case UPDATE_POST_COMMENTS:
      return {
        ...state,
        postList: {
          ...state.postList,
          data: {
            ...state.postList.data,
            posts: modifyPostComments(state.postList.data.posts, action.data),
          },
        },
      };
    case INCREMENT_POST_TIPS_COUNT:
      return {
        ...state,
        postList: {
          ...state.postList,
          data: {
            ...state.postList.data,
            posts: incrementPostTipCount(
              state.postList.data.posts,
              action.data
            ),
          },
        },
      };
    case UPDATE_POST_COMMENTS_COUNT:
      return {
        ...state,
        postList: {
          ...state.postList,
          data: {
            ...state.postList.data,
            posts: modifyPostCommentCount(
              state.postList.data.posts,
              action.data
            ),
          },
        },
      };
    case UPDATE_POST_BOOKMARK_STATUS:
      return {
        ...state,
        postList: {
          ...state.postList,
          data: {
            ...state.postList.data,
            posts: modifyPostBookmarkStatus(
              state.postList.data.posts,
              action.data
            ),
          },
        },
      };
    case OPEN_UNLOCK_CONTENT_MODAL:
      return {
        ...state,
        unlockContentModal: {
          isOpen: true,
          data: action.data,
        },
      };
    case CLOSE_UNLOCK_CONTENT_MODAL:
      return {
        ...state,
        unlockContentModal: {
          isOpen: false,
          data: action.data,
        },
      };
    case UPDATE_POST_SUCCESS:
      return {
        ...state,
        postList: {
          ...state.postList,
          data: {
            ...state.postList.data,
            posts: modifyPostOnUpdate(
              state.postList.data.posts,
              action.data
            ),
          },
        },
      };
    default:
      return state;
  }
};

export default HomeReducer;
